import { Box, Container } from '@mui/material';
import { useTranslation } from 'next-i18next';
import React from 'react';
import { TabsBar } from 'views/common/components';
import useGetTermsAndConditionsTabs from 'views/information-module/common/hooks/useGetTermsAndConditionsTabs';
import StyledBox, {
  StyledInfoPageTitle,
} from 'views/information-module/common/components/UI/TermsAndConditionsHeader/TermsAndConditionsHeader.styles';
import PATHS from 'lib/navigation/paths';

const TermsAndConditionsHeader = (props) => {
  const { t } = useTranslation();

  const {
    mainTitleObject = {
      name: t('fe_er_common_rentals_tab_bar:header'),
    },
    breadcrumbsObject = {
      links: [
        {
          text: t('fe_er_common_rentals_tab_bar:eagle_rider'),
          path: PATHS.home(),
        },
        {
          text: t('fe_er_common_rentals_tab_bar:information'),
          path: PATHS.information(),
        },
        {
          text: t('fe_er_common_rentals_tab_bar:terms_and_conditions'),
        },
      ],
    },
    selectedTab,
  } = props;

  const { tabs = [] } = useGetTermsAndConditionsTabs();
  return (
    <StyledBox>
      <StyledInfoPageTitle
        mainTitleObject={mainTitleObject}
        breadcrumbsObject={breadcrumbsObject}
        buttonText={t('fe_er_common_rentals_tab_bar:start_reservation')}
      />

      <Box className="RTACTabsBarWrapper">
        <Container maxWidth="xl">
          <TabsBar tabs={tabs} selectedTab={selectedTab} />
        </Container>
      </Box>
    </StyledBox>
  );
};

export { TermsAndConditionsHeader };
